import React, { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import swal from "sweetalert";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import Loader from "../Loader/Loader";

const NotificationType = () => {
  const [data, setData] = useState([]);
  const [notTypeOptions, setNotTypeOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [postModal, setPostModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editId, setEditId] = useState(null);

  const [formData, setFormData] = useState({
    UserId: 0,
    UserType: "",
    NotType: "",
    NotImageUrl: null,
  });

  const resetForm = () => {
    setFormData({
      UserId: "",
      UserType: "",
      NotType: "",
      NotImageUrl: null,
    });
  };

  const fetchNotTypeOptions = async () => {
    const val={"Source":"Drp"}
    const res = await AddUpdate(
      "NotificationMessage/GetData_NotificationMessage",
      val
    );

    const data = JSON.parse(res?.data?.data);
    const finaldata = data?.Table;

    if (finaldata && finaldata?.length > 0) {
      const uniqueTypes = [...new Set(finaldata?.map((item) => item.Type))];
      
      setNotTypeOptions(uniqueTypes);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    const res = await AddUpdate(
      "NotificationQueue/GetData_NotificationQueue",
      {}
    );
    if (res?.data?.data) {
      const datas = JSON.parse(res?.data?.data);
      const finaldata = datas?.Table;
      setData(finaldata);
      setLoading(false);
    }
  };

  const fetchSingleData = async (id) => {
    const res = await AddUpdate(
      "NotificationQueue/GetSingleData_NotificationQueue",
      { NotId: id }
    );
    if (res?.data?.data) {
      const finaldata = JSON.parse(res?.data?.data);

      const record = finaldata.Table[0];
      setFormData({
        UserId: record.UserId || 0,
        UserType: record.UserType,
        NotType: record.NotType,
        NotImageUrl: record.NotImageUrl,
      });
    }
  };

  useEffect(() => {
    fetchNotTypeOptions();
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, NotImageUrl: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

if (!formData.UserId || !formData.UserType || !formData.NotType) {
    swal("Error", "UserId, UserType, and NotType are required!", "error");
    return;
  }


    const payload = new FormData();
    const obj = {
      UserId: formData.UserId,
      UserType: formData.UserType,
      NotType: formData.NotType,
    };
    payload.append("Data", JSON.stringify(obj));

    if (formData.NotImageUrl) {
      payload.append("NotImageUrl", formData.NotImageUrl);
    }

    await AddUpdate("NotificationQueue/Insert_NotificationQueue", payload);
    swal("Good job!", "Successfully Added", "success");
    setPostModal(false);
    resetForm();
    fetchData();
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    const obj = {
      UserId: formData.UserId,
      UserType: formData.UserType,
      NotType: formData.NotType,
      NotId:editId
    };
    payload.append("Data", JSON.stringify(obj));




    await AddUpdate("NotificationQueue/Update_NotificationQueue", payload);
    swal("Good job!", "Successfully Updated", "success");
    setEditModal(false);
    resetForm();
    fetchData();
  };

  const handleDelete = async (id) => {
    await AddUpdate("NotificationQueue/Delete_NotificationQueue", {
      NotId: id,
    });
    swal("Deleted!", " Deleted Successfully", "success");
    fetchData();
  };

  const handleEditClick = (row) => {
    setEditId(row.NotId);
    fetchSingleData(row.NotId);
    setEditModal(true);
  };

  const isFormInvalid =
    !formData.UserId || !formData.UserType || !formData.NotType;

  const columns = [
    { name: "User Id", selector: (row) => row.UserId || "-", sortable: true },
    { name: "User Type", selector: (row) => row.UserType, sortable: true },
    {
      name: "Notification Type",
      selector: (row) => row.NotType,
      sortable: true,
    },
    {
      name: "Image",
      selector: (row) => row.NotImageUrl,
      sortable: true,
      cell: (row) => (
        <div className="concierge-bx d-flex align-items-center">
          {row.NotImageUrl ? (
            <img
              className="me-3 rounded"
              src={`https://${row.NotImageUrl.replace(/\\/g, "/")}`}
              alt="Image"
            />
          ) : (
            // <img className="me-3 rounded" src={user} />
            <span className="me-3 rounded"></span>
          )}
        </div>
      ),
    },
    {
      name: "Send Date",
      selector: (row) => row.SendDate,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <Dropdown>
          <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                stroke="#342E59"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                stroke="#342E59"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                stroke="#342E59"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Dropdown.Toggle>
          <Dropdown.Menu align="end">
            <Dropdown.Item onClick={() => handleEditClick(row)}>
              Edit
            </Dropdown.Item>
            <Dropdown.Item
              className="text-danger"
              onClick={() => handleDelete(row.NotId)}
            >
              Delete
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ),
    },
  ];

  return (
    <>
      <h2 style={{ color: "#f7931e", fontWeight: 700 }}>Notification Queue</h2>

      <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap ">
        <div className="card-action coin-tabs"></div>
        <button
          className="btn btn-primary font-w600"
          onClick={() => {
            setPostModal(true);
            resetForm();
          }}
        >
          + New Notification Queue
        </button>
      </div>

      <Modal
        show={postModal}
        onHide={() => setPostModal(false)}
        backdrop="static"
      >
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="modal-header">
            <h4 className="modal-title fs-20">Add Notification Queue</h4>
            <button
              type="button"
              className="btn-close"
              onClick={() => setPostModal(false)}
            />
          </div>
          <div className="modal-body p-3">
            <div className="form-group mb-2">
              <label>User Id/Ids<span className="text-danger star-error" >*</span></label>
              <input
                type="text"
                name="UserId"
                className="form-control"
                value={formData.UserId}
                onChange={handleInputChange}
                placeholder="Enter User Id"
              />
            </div>

            <div className="form-group mb-2">
              <label>User Type<span className="text-danger star-error" >*</span></label>
              <select
                name="UserType"
                className="form-control"
                value={formData.UserType}
                onChange={handleInputChange}
              >
                <option value="">-- Select User Type --</option>
                <option value="Astrologer">Astrologer</option>
                <option value="User">User</option>
              </select>
            </div>

            <div className="form-group mb-2">
              <label>Notification Type<span className="text-danger star-error" >*</span></label>
              <select
                name="NotType"
                className="form-control"
                value={formData.NotType}
                onChange={handleInputChange}
              >
                <option value="">-- Select Notification Type --</option>
                {notTypeOptions?.map((type, index) => (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group mb-2">
              <label>Notification Image</label>
              <input
                type="file"
                className="form-control"
                onChange={handleFileChange}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
               disabled={!formData.UserId || !formData.UserType || !formData.NotType}
            >
              Save
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setPostModal(false)}
            >
              Close
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        show={editModal}
        onHide={() => setEditModal(false)}
        backdrop="static"
      >
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="modal-header">
            <h4 className="modal-title fs-20">Edit Notification Queue</h4>
            <button
              type="button"
              className="btn-close"
              onClick={() => setEditModal(false)}
            />
          </div>
          <div className="modal-body p-3">
            <div className="form-group mb-2">
              <label>User Id/Ids<span className="text-danger star-error" >*</span></label>
              <input
                type="text"
                name="UserId"
                className="form-control"
                value={formData.UserId}
                onChange={handleInputChange}
                placeholder="Enter User Id"
              />
            </div>

            <div className="form-group mb-2">
              <label>User Type<span className="text-danger star-error" >*</span></label>
              <select
                name="UserType"
                className="form-control"
                value={formData.UserType}
                onChange={handleInputChange}
              >
                <option value="">-- Select User Type --</option>
                <option value="Astrologer">Astrologer</option>
                <option value="User">User</option>
              </select>
            </div>

            <div className="form-group mb-2">
              <label>Notification Type<span className="text-danger star-error" >*</span></label>
              <select
                name="NotType"
                className="form-control"
                value={formData.NotType}
                onChange={handleInputChange}
              >
                <option value="">-- Select Notification Type --</option>
                {notTypeOptions?.map((type, index) => (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>

           
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleUpdate}
               disabled={!formData.UserId || !formData.UserType || !formData.NotType}
            >
              Update
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setEditModal(false)}
            >
              Close
            </button>
          </div>
        </form>
      </Modal>

      <div className="col-12 mt-2">
        {loading ? (
          <Loader />
        ) : (
          <DataTable
            dense
            data={data}
            columns={columns}
            pagination
            persistTableHead
            noDataComponent="No data available"
            customStyles={customStyles}
          />
        )}
      </div>
    </>
  );
};

export default NotificationType;
